import { Radio, RadioProps, Form, FormControlProps, RadioGroup } from "rsuite";
import { useState, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../../core/redux/reduxStore";
import { ActionUI } from "../../../core/redux/slices/sliceUI";

type RadioInputProps = {
  showError?: boolean;
  errorText?: string;
  onTrialOrPaidChecked?: (isTrial: boolean) => void;
} & FormControlProps &
  RadioProps;

export const RadioFormInput = ({
  name,
  checked,
  onTrialOrPaidChecked,
  ...props
}: RadioInputProps) => {
  const [paidCheckValue, setPaidCheckValue] = useState<boolean>(
    checked || false
  );
  const [trialCheckValue, setTrialCheckValue] = useState<boolean>(
    checked || false
  );
  const { userFormError } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (checked === true) {
      setPaidCheckValue(true);
    } else {
      setTrialCheckValue(true);
    }
  }, []);

  const errorStyles = (errorVisible: any) => {
    return {
      display: errorVisible ? "block" : "none",
      color: "red",
      marginTop: 6,
    };
  };

  const trialOrPaidCheck = (value: string) => {
    if (onTrialOrPaidChecked != null)
      onTrialOrPaidChecked(value === "trial" ? true : false);
  };

  return (
    <div className="d-block">
      <Form.Group
        controlId={name}
        className="d-flex align-items-center m-0 p-0"
      >
        <Form.Control
          accepter={RadioGroup}
          name={name}
          onChange={() => {
            if ((userFormError as any)[name]) {
              dispatch(
                ActionUI.setUserFormError({ ...userFormError, [name]: false })
              );
            }
          }}
          inline
        >
          <Radio
            value="trial"
            checked={trialCheckValue}
            onChange={() => trialOrPaidCheck("trial")}
          >
            Trial User
          </Radio>
          <Radio
            value="paid"
            checked={paidCheckValue}
            onChange={() => trialOrPaidCheck("paid")}
          >
            Paid User
          </Radio>
        </Form.Control>
      </Form.Group>
      {props.showError && props.errorText ? (
        <div style={errorStyles((userFormError as any)[name])}>
          {props.errorText}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
